import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import type { DefaultOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { handleError } from "../utils/error";

const queryConfig: DefaultOptions = {
  queries: {
    retry: false,
    throwOnError: false,
    refetchOnWindowFocus: false,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
  queryCache: new QueryCache({
    onError: (error) => handleError(error as AxiosError<any, any>),
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // If the mutation has its own onError, skip
      if (mutation.options.onError) return;

      handleError(error as AxiosError<any, any>);
    },
  }),
});
